/* This file was automatically generated by CoralTypeScriptTypesBuildLogic -- do not modify. */
import { CoralClientConfigFactory } from "@amzn/ihm-js-coral-client/client";
/**
 * Coral client configuration factory for TransReportsCenterService
 */
export const TransReportsCenterServiceClientConfigFactory = new CoralClientConfigFactory("TransReportsCenterService", {
    "master.USAmazon": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal",
        },
        rpc: { encoding: "text", version: "v1" },
        httpEndpoint: {
            url: "https://iad.gamma.trcs.transportation.amazon.dev/",
        },
        timeouts: { operationTimeouts: { "TransReportsCenterService/*": 10000 } },
        inputValidation: {},
        protocols: ["rpc"],
        cloudAuth: { enabled: "true" },
    },
    "Base.Gamma": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal",
        },
        rpc: { encoding: "text", version: "v1" },
        httpEndpoint: {
            url: "https://iad.gamma.trcs.transportation.amazon.dev/",
        },
        timeouts: { operationTimeouts: { "TransReportsCenterService/*": 10000 } },
        inputValidation: {},
        protocols: ["rpc"],
        cloudAuth: { enabled: "true" },
    },
    "master.passport.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.gamma.passport.transportation.a2z.com/",
        },
    },
    "Base.Beta": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal",
        },
        rpc: { encoding: "text", version: "v1" },
        httpEndpoint: { url: "https://iad.beta.trcs.transportation.amazon.dev/" },
        timeouts: { operationTimeouts: { "TransReportsCenterService/*": 10000 } },
        inputValidation: {},
        protocols: ["rpc"],
        cloudAuth: { enabled: "true" },
    },
    "prod.carrierlogistics.USAmazon": {
        httpEndpoint: { url: "https://carrierlogistics.amazon.com/" },
    },
    "Carrierlogistics.Beta.USAmazon": {
        httpEndpoint: { url: "https://carrierlogistics.integ.amazon.com/" },
    },
    Base: {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal",
        },
        rpc: { encoding: "text", version: "v1" },
        timeouts: { operationTimeouts: { "TransReportsCenterService/*": 10000 } },
        inputValidation: {},
        protocols: ["rpc"],
        cloudAuth: { enabled: "true" },
    },
    "prod.USAmazon": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal",
        },
        rpc: { encoding: "text", version: "v1" },
        httpEndpoint: { url: "https://iad.prod.trcs.transportation.amazon.dev/" },
        timeouts: { operationTimeouts: { "TransReportsCenterService/*": 10000 } },
        inputValidation: {},
        protocols: ["rpc"],
        cloudAuth: { enabled: "true" },
    },
    "Carrierlogistics.Prod.USAmazon": {
        httpEndpoint: { url: "https://carrierlogistics.amazon.com/" },
    },
    "test.carrierlogistics.USAmazon": {
        httpEndpoint: { url: "https://carrierlogistics.integ.amazon.com/" },
    },
    "master.carrierlogistics.USAmazon": {
        httpEndpoint: { url: "https://carrierlogistics-gamma.aka.amazon.com/" },
    },
    "Passport.Beta.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.beta.passport.transportation.a2z.com/",
        },
    },
    "test.USAmazon": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal",
        },
        rpc: { encoding: "text", version: "v1" },
        httpEndpoint: { url: "https://iad.beta.trcs.transportation.amazon.dev/" },
        timeouts: { operationTimeouts: { "TransReportsCenterService/*": 10000 } },
        inputValidation: {},
        protocols: ["rpc"],
        cloudAuth: { enabled: "true" },
    },
    "prod.passport.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.prod.passport.transportation.a2z.com/",
        },
    },
    "Passport.Prod.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.prod.passport.transportation.a2z.com/",
        },
    },
    "Carrierlogistics.Gamma.USAmazon": {
        httpEndpoint: { url: "https://carrierlogistics-gamma.aka.amazon.com/" },
    },
    "UI.Testing.Local": { httpEndpoint: { url: "http://localhost:3000/" } },
    "Passport.Gamma.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.gamma.passport.transportation.a2z.com/",
        },
    },
    "test.passport.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.beta.passport.transportation.a2z.com/",
        },
    },
    "desktop.USAmazon": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal",
        },
        rpc: { encoding: "text", version: "v1" },
        httpEndpoint: { url: "http://127.0.0.1:8080/" },
        timeouts: { operationTimeouts: { "TransReportsCenterService/*": 10000 } },
        inputValidation: {},
        protocols: ["rpc"],
        cloudAuth: { enabled: "true" },
    },
    "Base.Development": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal",
        },
        rpc: { encoding: "text", version: "v1" },
        httpEndpoint: { url: "http://127.0.0.1:8080/" },
        timeouts: { operationTimeouts: { "TransReportsCenterService/*": 10000 } },
        inputValidation: {},
        protocols: ["rpc"],
        cloudAuth: { enabled: "true" },
    },
    "Base.Prod": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal",
        },
        rpc: { encoding: "text", version: "v1" },
        httpEndpoint: { url: "https://iad.prod.trcs.transportation.amazon.dev/" },
        timeouts: { operationTimeouts: { "TransReportsCenterService/*": 10000 } },
        inputValidation: {},
        protocols: ["rpc"],
        cloudAuth: { enabled: "true" },
    },
});
